import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Logo } from "../components/Logo";

export function DemoShell({ embedded, children }: { embedded: boolean; children: ReactNode }) {
  if (embedded) {
    return <main className="demo-shell is-embedded">{children}</main>;
  }
  return (
    <div className="demo-page">
      <header className="site-header">
        <div className="container header-row">
          <Logo />
          <Link to="/" className="btn btn-ghost btn-sm">
            Back to site
          </Link>
        </div>
      </header>
      <main id="main" className="demo-shell">
        {children}
      </main>
    </div>
  );
}
